<template>
    <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()==true || $gate.isHRAdmin()==true">
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="/home">Home</a></li>
                            <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
                        </ol>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br>
<!--            <div class="col-lg-12">-->
<!--                <div class="card card-danger card-outline collapsed-card">-->
<!--                    <div class="card-header">-->
<!--                        <div class="card-title">Data Filters</div>-->
<!--                        <div class="card-tools">-->
<!--                            &lt;!&ndash; Collapse Button &ndash;&gt;-->
<!--                            <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                        <div class="col-lg-12 float-left">-->
<!--                            <div class="row">-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Saved to SAP:</span>-->
<!--                                        <select class="form-control" v-model="params.sap_pushed">-->
<!--                                            <option value="1">Yes</option>-->
<!--                                            <option value="0">No</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Customer Type:</span>-->
<!--                                        <select class="form-control" v-model="params.customer_type">-->
<!--                                            <option value="b2c">B2C</option>-->
<!--                                            <option value="b2b">B2B</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Payment Status:</span>-->
<!--                                        <select class="form-control" v-model="params.payment_status">-->
<!--                                            <option value="Pending">Pending</option>-->
<!--                                            <option value="Completed">Completed</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Order Source:</span>-->
<!--                                        <select class="form-control" v-model="params.source">-->
<!--                                            <option value="POS">POS</option>-->
<!--                                            <option value="E-Commerce">E-Commerce</option>-->
<!--                                            <option value="CARE">Service</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Delivery Mode:</span>-->
<!--                                        <select class="form-control" v-model="params.delivery_mode">-->
<!--                                            <option v-for="j in delivery_modes" :value="j.mode">{{j.mode}}</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4" v-if='$gate.isWarehouseManager()==true || $gate.isZonalManager()==true || $gate.isMISAdmin()==true'>-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Branch:</span>-->
<!--                                        <select class="form-control" v-model="params.branch">-->
<!--                                            <option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Created |From Date:</span>-->
<!--                                        <input type="date" class="form-control" v-model="params.from_date" placeholder="From date">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Created |To Date:</span>-->
<!--                                        <input type="date" class="form-control" v-model="params.to_date" placeholder="To date">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Phone Number:</span>-->
<!--                                        <input class="form-control" placeholder="Enter a phone number" v-model="params.phone" type="number" min="1000000000">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">SAP Doc Number:</span>-->
<!--                                        <input class="form-control" placeholder="Enter SAP Doc Number" v-model="params.sapdoc" type="text">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="row">-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <button class="btn btn-primary" style="width:100% !important;"  @click="getOrders('/api/getSaleOrders')">Search</button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4" v-if='$gate.isMISAdmin()'>-->
<!--                                    <div class="form-group">-->
<!--                                        <button class="btn btn-success" style="width:100% !important;" @click="exportOrders">Export</button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-sm-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <br>
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <table class="table table-hover table-striped table-bordered">
                            <thead class="thead-dark">
                            <tr>
                                <th scope="col">PID#</th>
                                <th scope="col">Image</th>
                                <th scope="col">User Details</th>
                                <th scope="col">Lead Profile Details</th>
                                <th scope="col">Status</th>
                                <th scope="col">Manage</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in image_uploads">
                                <td>{{item.id}}</td>
                                <td><p><img class="img-circle profile-image" style="border-radius: 50% !important; height: 7rem !important; width: 7rem !important;" :src="item.image_url" alt="User profile picture"></p></td>
                                <td>
                                    <p v-if="item.emp_id !='' "><span class="badge badge-warning">{{item.user_id}}</span>&nbsp; <span class="badge badge-danger">{{item.user.branch}}</span>&nbsp;<span class="badge badge-secondary">{{item.user.emp_id}}</span></p>
                                    <p>{{item.user.first_name}} {{item.user.last_name}}
                                        <br>
                                    {{item.user.phone}} &nbsp; <span class="badge badge-primary">{{item.user.user_type}}</span>
                                        <br>
                                    {{item.user.email}}</p>
                                </td>
                                <td>
                                    <p><span class="badge badge-warning">{{item.lead_profile_id}}</span></p>
                                    <p>{{item.lead_profile.name}} &nbsp; <span class="badge badge-secondary">{{item.lead_profile.gender}}</span>&nbsp; <span class="badge badge-danger">{{item.user.blood_group}}</span>
                                    <p v-if="$gate.isSysAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isCCManager()">
                                        {{item.lead_profile.mobile}} &nbsp; {{item.lead_profile.alt_mobile}}<br>
                                        {{item.lead_profile.email}}
                                    </p>

                                </td>
                                <td>
                                    <h5 v-if="item.verified==false"><span class="badge badge-danger">NOT APPROVED</span></h5>
                                    <h5 v-if="item.verified==true"><span class="badge badge-success">APPROVED</span></h5>
                                </td>
                                <td>
                                    <p><button class="btn btn-secondary" style="width: 100% !important;" @click="changeStatus(item)">Change Status <i class="fa fa-wrench" aria-hidden="true"></i></button></p>
                                    <p v-if="$gate.isSysAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isCCManager()"><button class="btn btn-secondary" style="width: 100% !important;" @click="viewProfile(item)">View Profile <i class="fa fa-eye" aria-hidden="true"></i></button></p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination :pagination="pagination"
                                    @prev="getAllUploadedImages(pagination.prevPageUrl)"
                                    @next="getAllUploadedImages(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
                <br><br>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin() && !$gate.isHRAdmin()">
            <access-denied></access-denied>
        </div>

        <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="discountModal" aria-hidden="true" id="uploadedImageStatusModal">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Uploaded Image Status</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body overflow-auto">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 justify-content-center">
                                    <div class="row">
                                        <img style="height: auto !important; width: 70% !important;" :src="form.image_url" alt="User profile picture">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                        <div class="form-group">
                                            <label>ID:</label>
                                            <input class="form-control" style="width:100% !important;" v-model="form.id" type="number" placeholder="Enter the customer number" min="1000000000" disabled>
                                        </div>
                                        <div class="form-group">
                                            <label>Lead ID</label>
                                            <input class="form-control" style="width:100% !important;" v-model="form.lead_profile_id" type="text" disabled>
                                        </div>
                                        <div class="form-group">
                                            <label>Profile ID</label>
                                            <input class="form-control" style="width:100% !important;" v-model="form.user_id" type="text" disabled>
                                        </div>
                                        <div class="form-group">
                                            <label>Image URL</label>
                                            <input class="form-control" style="width:100% !important;" v-model="form.image_url" type="text" disabled>
                                        </div>
                                        <div class="form-group" v-if="form.verified==false">
                                            <button class="btn btn-success" style="width:100% !important;" @click="accept">Accept</button>
                                        </div>
                                        <div class="form-group" v-if="form.verified==true">
                                            <button class="btn btn-danger" style="width:100% !important;" @click="deny">Deny</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading
            :show="lshow"
            :label="llabel">
        </loading>
    </div>
</template>

<script>
import Pagination from '../../pagination.vue';
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log('Component mounted.')
    },

    components: {pagination: Pagination, loading},

    created(){
        this.getAllUploadedImages();
    },

    data(){
        return{
            orders: [],
            results: '',
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },

            params: new Form({
                sap_pushed: null,
                customer_type: null,
                delivery_mode: null,
                phone: null,
                sapdoc: null,
                gatepass: null,
                from_date: null,
                to_date: null,
                source: null,
                order_id: null,
                payment_mode: null,
                finance_mode: null,
                payment_status: null,
                branch: null
            }),
            form: new Form({
                lead_profile_id:'',
                user_id:'',
                id:'',
                image_url:'',
                verified:''
            }),
            delivery_modes: [],
            lshow: '',
            llabel: 'Please Wait...',
            pms: [],
            fms: [],
            branches: [],
            image_uploads:[],
        }
    },

    methods: {

        getAllUploadedImages(){
            axios.post("/api/getUploadedProfileImages",{results: this.results, params: this.params})
                    .then(response => {
                        this.image_uploads = response.data.data;
                        this.configPagination(response.data);
                    })
        },


        configPagination(data){
            this.pagination.lastPage=data.lastPage;
            this.pagination.currentPage=data.current_page;
            this.pagination.total=data.total;
            this.pagination.lastPageUrl=data.last_page_url;
            this.pagination.nextPageUrl=data.next_page_url;
            this.pagination.prevPageUrl=data.prev_page_url;
            this.pagination.from=data.from;
            this.pagination.to=data.to;
        },

        reset(){
            this.params.reset();
            this.getOrders();
        },

        viewProfile(entry){
            // this.$router.push('/user-profile/'+entry.user_id);
            this.$router.push({
                name: 'User Profile | O2Suite::Greydesk',
                params: {user_id:entry.user_id, lead_profile_id:entry.lead_profile_id}
            });
        },

        changeStatus(item){
            this.form.fill(item);
            $("#uploadedImageStatusModal").modal("show");
        },

        accept(){
            this.lshow = true;
            axios.post("/api/acceptProfileImageUpload", {id: this.form.id})
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Image Approved"
                    });
                    $("#uploadedImageStatusModal").modal("hide");
                    this.getAllUploadedImages("/api/getUploadedProfileImages"+'?page='+this.pagination.currentPage);
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed"
                    });
                    $("#uploadedImageStatusModal").modal("hide");
                    this.getAllUploadedImages("/api/getUploadedProfileImages"+'?page='+this.pagination.currentPage);
                });
            this.lshow = false;
        },

        deny(){
            this.lshow = true;
            axios.post("/api/denyProfileImageUpload", {id: this.form.id})
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Image Approved"
                    });
                    $("#uploadedImageStatusModal").modal("hide");
                    this.getAllUploadedImages("/api/getUploadedProfileImages"+'?page='+this.pagination.currentPage);
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed"
                    });
                    $("#uploadedImageStatusModal").modal("hide");
                    this.getAllUploadedImages("/api/getUploadedProfileImages"+'?page='+this.pagination.currentPage);
                });
            this.lshow = false;
        }
    }
}
</script>
